import { useCurrency } from '@shared/selectors/globalSelectors';
import React from 'react';

export default function FlatRate({ data }: { data: any }) {
  const rateValue = data?.[0]?.rate ?? data?.rate ?? data?.fixed ?? data?.[0]?.fixed ?? 0;
  const unit = data?.[0]?.unit ?? data?.unit ?? "N/A";
  const currency = useCurrency();
  return (
    <div className="flex items-baseline gap-1.5 mt-1">
      <div className="text-sm font-semibold text-slate-900">
        {currency} {rateValue} <span className="text-slate-400 font-normal">/</span>
      </div>
      <div className="text-xs font-medium text-slate-500">{unit}</div>
    </div>
  );
}
